import { render, staticRenderFns } from "./OrgMonitorRating.vue?vue&type=template&id=3459ba56"
import script from "./OrgMonitorRating.vue?vue&type=script&lang=js"
export * from "./OrgMonitorRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports